import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import ModalComentario from "./CreaComentarioJunta";

const ComentariosSolicitud = () => {
  const { id } = useParams();
  const [comentarios, setComentarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  // ⚠️ reemplaza esto por tu usuario real (cookie/token)
  const usuarioId = 1295;

  const cargarComentarios = async () => {
    try {
      const res = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/ObtenerComentarios/${id}`,
      );

      // 🔥 ordenar por fecha DESC (más reciente primero)
      const ordenados = res.data.sort(
        (a, b) => new Date(b.fecha) - new Date(a.fecha),
      );

      setComentarios(ordenados);
    } catch (error) {
      console.error("Error cargando comentarios", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) cargarComentarios();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white d-flex justify-content-between">
          <h5 className="m-0">Comentarios</h5>

          <button
            className="btn btn-light btn-sm"
            onClick={() => setModalOpen(true)}
          >
            + Nuevo
          </button>
        </div>

        <div className="card-body">
          {comentarios.length === 0 ? (
            <div className="alert alert-warning">
              No hay comentarios registrados.
            </div>
          ) : (
            <div className="list-group">
              {comentarios.map((item) => (
                <div
                  key={item.id}
                  className="list-group-item mb-2 shadow-sm"
                  style={{ borderRadius: "10px" }}
                >
                  <div className="d-flex justify-content-between">
                    <h6 className="mb-1">Usuario: {item.nombreUsuario}</h6>
                    <small className="text-muted">
                      {new Date(item.fecha).toLocaleString()}
                    </small>
                  </div>

                  <p className="mb-1">{item.comentarios}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* 🔥 MODAL */}
      <ModalComentario
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        solicitudId={id}
        usuarioId={usuarioId}
        onComentarioCreado={cargarComentarios}
      />
    </div>
  );
};

export default ComentariosSolicitud;
